export const donationStatus = "4.630";
export const donationStatus_Used = "41.217";
export const donationStatus_Independent = "22.168";
export const donationStatus_Project = "19.048";
